import { registerStoreItem, DISABLED_ACTION_COMMIT } from 'utils/storeCreator'
import {
  teacherListOption,
  teacherList,
  teacherListAd,
  consultUser,
  channelInfo,
  recentTeachers
} from 'api/consult'

let store = registerStoreItem({
  store: {
    namespaced: true,
    state: {
      teacherList: [],
      sideMenus: [],
      bannerData: {},
      page: 0
    },

    mutations: {
      SET_TEACHER_LIST(state, { list, page }) {
        if (!list) return
        state.teacherList =
          page === 1 ? [...list] : [...state.teacherList, ...list]
      },

      SET_BANNER(state, data) {
        state.bannerData = data
      },
      SET_SIDE_MENUS(state, { channelId, list }) {
        if (list) {
          state.sideMenus = list
          return
        }
        //  页面初始化
        let arealist = channelId
          ? [state.selectOption.areas[0]]
          : state.selectOption.areas

        state.sideMenus = arealist.length ? arealist[0].list : []
      }
    },
    actions: {
      getTeacherList({ commit }, payload = {}) {
        return teacherList(payload).then(res => {
          if (res.code === 0) {
            let list = res.data
            commit('SET_TEACHER_LIST', {
              list,
              page: payload.page
            })
            return res
          }
        })
      },

      getBanner({ commit }, payload) {
        return teacherListAd(payload).then(res => {
          if (res && Object.keys(res).length) {
            commit('SET_BANNER', res)
          }
        })
      }
    },
    getters: {
      parseRecentTeachers(state) {
        const { recentTeachers } = state
        let result = Object.keys(recentTeachers)
          .map(k =>
            k === 'current_time' || Array.isArray(recentTeachers[k])
              ? null
              : Object.assign({ _recent_type_: k }, recentTeachers[k])
          )
          .filter(v => !!v)

        return result
      }
    }
  },

  name: 'selectOption',
  api: teacherListOption,
  handle: res => {
    const { code, data } = res
    // const { channelId } = params
    if (code === 0) {
      return data
    } else {
      return DISABLED_ACTION_COMMIT
    }
  },
  defaultValue: {
    areas: [],
    labels: {},
    tags: []
  }
})

store = registerStoreItem({
  store,
  name: 'userInfo',
  api: consultUser,
  handle: data => data.data,
  defaultValue: {
    user_id: '',
    role: ''
  }
})

store = registerStoreItem({
  store,
  name: 'channelInfo',
  api: channelInfo,
  handle: data => data.data,
  defaultValue: {
    out_channel: '',
    in_channel: ''
  }
})

store = registerStoreItem({
  store,
  name: 'recentTeachers',
  api: recentTeachers,
  handle: data => data.data,
  defaultValue: {
    pay: [],
    view: []
  }
})

export default {
  name: 'consultList',
  store
}
